var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreshpingmonitoringService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 117 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "fill-current w-8 h-8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1 116C26.2 116 .4 90.2.4 58.3.4 26.4 26.2.6 58.1.6h43.4c8.1 0 14.6 6.4 14.6 14.6v43.1c0 31.9-25.8 57.7-58 57.7Z",
    fill: "#ED7C02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 57.3c.7 0 1.7.3 2 1l5.8 7.8 6.4-18.7c.3-1 1-1.4 2-1.7 1 0 1.7.3 2.4 1l8.1 10.9h13.9c-.3-15.3-12.9-27.5-28.2-27.5-15.3 0-27.8 12.2-28.2 27.5h15.6v-.3h.2Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3 62.4c-.7 0-1.7-.3-2-1l-6.1-8.1-6.4 19c-.3 1-1 1.7-2 1.7h-.3c-.7 0-1.7-.3-2-1l-7.8-10.5H30.4c2 13.6 13.6 24.1 27.8 24.1C72.4 86.6 84 76.1 86 62.5c-.1-.1-14.7-.1-14.7-.1Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshpingmonitoringService);
export default __webpack_public_path__ + "static/media/freshping.monitoring-service.ffc1424212e67862590088b268c4f8be.svg";
export { ForwardRef as ReactComponent };